export default "__VITE_ASSET__DDdtxP_N__"